import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getAssetClosure = (projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/closure/${projectCode}/page?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchAssetClosure = (request, projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/closure/${projectCode}/search?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const getAssetList = (projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/asset/${projectCode}/page?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchAssetList = (request, projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/asset/${projectCode}/search?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const getAssetClosureById = (projectCode, id, step) => {
  const url = `${API_ROOT_VER}/asset-closure/request/${projectCode}/${step}?id=${id || ''}`
  return doGet(url)
}

export const saveAssetClosureRequest = (request, projectCode, period) => {
  const url = `${API_ROOT_VER}/asset-closure/request/${projectCode}/${period}`
  return doPostFiles(url, request)
}

export const getAssetClosureApprove = (level, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/approve/page/${level}?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchAssetClosureApprove = (request, level, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-closure/approve/search/${level}?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const assetClosureApproveRequestApprover = (request, level) => {
  const url = `${API_ROOT_VER}/asset-closure/approve/request-approve/${level}`
  return doPut(url, request)
}

export const assetClosureApproveApproverSubmit = (request, level) => {
  const url = `${API_ROOT_VER}/asset-closure/approve/approver-submit/${level}`
  return doPut(url, request)
}

// จัดการครุภัณฑ์-ปิดโครงการ (ภาคี)
export const saveResponsinatorAssetClosureRequest = (request) => {
  // /api/v1/accounting/asset-closure/request
  const url = `${API_ROOT_VER}/asset-closure/request`
  return doPostFiles(url, request)
}

export const updateResponsinatorAssetClosureRequest = (request) => {
  // /api/v1/accounting/asset-closure/request
  const url = `${API_ROOT_VER}/asset-closure/update`
  return doPostFiles(url, request)
}

export const downloadAssetClosureAttacthment = (fileId) => {
  // /api/v1/accounting/asset-closure/request/attachments/download/{fileId}
  const url = `${API_ROOT_VER}/asset-closure/request/attachments/download/${fileId}`
  return doDownload(url)
}

export const deleteAssetClosure = (id) => {
  // /api/v1/accounting/asset-closure/request/{id}
  const url = `${API_ROOT_VER}/asset-closure/request/${id}`
  return doDelete(url)
}

export const cancelAssetClosure = (id) => {
  // /api/v1/accounting/asset-closure/cancel-request/{id}
  const url = `${API_ROOT_VER}/asset-closure/cancel-request/${id}`
  return doDelete(url)
}

// เสนอพืจารณาอนุมัติคำขอปิดครุภัณฑ์ นักวิชาการ/จนท.พัสดุ
export const updateApproveLevel1AssetClosureRequest = (request, step) => {
  // /api/v1/accounting/asset-closure/approve/request-approve
  const url = `${API_ROOT_VER}/asset-closure/approve/request-approve/${step}`
  return doPut(url, request)
  // return doPutFiles(url, request)
}

// อนุมัติคำขอปิดครุภัณฑ์ ผอ./ผอ.อำนวยการ
export const updateApproveLevel2AssetClosureRequest = (request, step) => {
  // /api/v1/accounting/asset-closure/approve/approver-submit
  const url = `${API_ROOT_VER}/asset-closure/approve/approver-submit/${step}`
  return doPut(url, request)
}

export const downloadFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

//พน.3
export const downloadAssetClouerRegisterFile = (projectCode, closureId) => {
  const url = `${API_ROOT}/files/${projectCode}/asset/register/form?closureId=${closureId || ''}`
  return doDownload(url)
}

//#region [ตรวจนับครุภัณฑ์]
// แสดง รายการตรวจนับ (ภาคี, จนท พัสดุ)
export const getAssetCountPage = (projectCode, pageNumber, pageSize) => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/list/1/page?pageNumber=55&pageSize=666
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/list/page?projectCode=111&pageNumber=222&pageSize=333
  const url = `${API_ROOT_VER}/asset-count/list/page?projectCode=${projectCode}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const creatAssetCount = (request = {}, projectCode = '', budgetYear = 0) => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/init/0900?budgetYear=11

  const url = `${API_ROOT_VER}/asset-count/init/${projectCode}?budgetYear=${budgetYear}`
  return doPost(url, request)
}

export const searchAssetCount = (request, pageNumber = 0, pageSize = 0) => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/list/we3w/search?pageNumber=22&pageSize=11
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/list/search?pageNumber=11&pageSize=22
  const url = `${API_ROOT_VER}/asset-count/list/search?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doPost(url, request)
}

// แสดงคำขอตรวจนับ หน้าหลัก (ภาคี, จนท พัสดุ)
export const getDisplayAddAssetCountPage = (assetCountId = '') => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/form/assetCountId
  const url = `${API_ROOT_VER}/asset-count/form/${assetCountId}`
  return doGet(url)
}

export const searchAssetCountDetail = (assetCountDetailId) => {
  // const API_ROOT_VER = 'http://localhost:80/api/v1/accounting'
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/get/122
  const url = `${API_ROOT_VER}/asset-count/get/${assetCountDetailId}`
  return doGet(url)
}

export const saveAssetCount = (request) => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/save
  const url = `${API_ROOT_VER}/asset-count/save`
  return doPost(url, request)
}

export const saveAssetCountSendToReview = (request, assetCountId) => {
  // http://103.91.191.229:9000/api/v1/accounting/asset-count/send-to-review/assetCountId
  const url = `${API_ROOT_VER}/asset-count/send-to-review/${assetCountId}`
  return doPut(url, request)
}

export const saveAssetCountReviewSubmit = (request) => {
  // /api/v1/accounting/asset-count/review-submit
  const url = `${API_ROOT_VER}/asset-count/review-submit`
  return doPut(url, request)
}

export const uploadAttachAssetCountFile = (request, assetCountId) => {
  // /api/v1/accounting/asset-count/uplaod-attach/{assetCountId}
  const url = `${API_ROOT_VER}/asset-count/uplaod-attach/${assetCountId}`
  return doPutFiles(url, request)
}

export const downloadAssetStockCountFile = (id, projectCode) => {
  // http://103.91.191.229:9000/api/files/asset/stock-count/report?id=111&projectCode=222
  const url = `${API_ROOT}/files/asset/stock-count/report?id=${id}&projectCode=${projectCode}`
  return doDownload(url)
}

//#endregion [ตรวจนับครุภัณฑ์]

export const getAssetRevolvingSchema = (pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-revolving/page?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const SearchAssetRevolving = (request) => {
  const url = `${API_ROOT_VER}/asset-revolving/search`
  return doPost(url, request)
}

export const SaveAssetRevolving = (request) => {
  const url = `${API_ROOT_VER}/asset-revolving/save`
  return doPost(url, request)
}
